module.exports = __webpack_public_path__ + "img/Zeke.fdabf366.jpg";